import React, { useState } from "react";
import CustomSelect from "@/components/ui/CustomSelect";
import { supabase } from "../supabaseClient";
import { useParams, useNavigate } from "react-router-dom";
import { AlertCircle, CheckCircle2 } from "lucide-react";

const Return = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [reason, setReason] = useState("");
  const [condition, setCondition] = useState("");
  const [message, setMessage] = useState("");
  const [isValidReturn, setIsValidReturn] = useState(null);

  const validReasons = [
    "Product Damaged",
    "Manufacturing Defect"
  ];

  const reasonOptions = [
    "Product Damaged",
    "Manufacturing Defect",
    "Change of Mind",
    "Color Difference",
    "Size Issue"
  ];

  const conditionOptions = ["Unused", "Used"];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid =
      validReasons.includes(reason) && condition === "Unused";

    await supabase.from("returns").insert([
      {
        order_id: orderId,
        reason,
        is_valid: isValid,
      },
    ]);

    setIsValidReturn(isValid);

    if (isValid) {
      setMessage("Return request submitted successfully.");
    } else {
      setMessage("Return cancelled – not eligible as per policy.");
    }

    setTimeout(() => navigate("/orders"), 2500);
  };

  return (
    <div className="bg-cream min-h-screen flex items-center justify-center px-6">
      <div className="bg-white border border-[#EAE4DC] shadow-lg rounded-2xl p-10 w-full max-w-md">
        
        {/* Heading */}
        <h2 className="font-serif text-3xl text-charcoal mb-8 text-center">
          Return Order #{orderId}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Reason */}
          <CustomSelect
            label="Reason"
            options={reasonOptions}
            value={reason}
            onChange={setReason}
          />

          {/* Condition */}
          <CustomSelect
            label="Product Condition"
            options={conditionOptions}
            value={condition}
            onChange={setCondition}
          />

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!reason || !condition}
            className="w-full bg-[#ba8245] text-white py-3 rounded-full shadow-md hover:bg-[#a8733d] transition-all duration-300 uppercase tracking-wider text-sm font-medium disabled:opacity-50"
          >
            Submit Return
          </button>
        </form>

        {/* Message */}
        {message && (
          <div
            className={`mt-6 flex items-center gap-3 p-4 rounded-lg border ${
              isValidReturn
                ? "bg-green-50 border-green-200 text-green-800"
                : "bg-red-50 border-red-200 text-red-800"
            }`}
          >
            {isValidReturn ? (
              <CheckCircle2 size={20} />
            ) : (
              <AlertCircle size={20} />
            )}
            <p className="text-sm">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Return;